module.exports = __webpack_public_path__ + "static/media/about_main_img.9107ab3c.jpg";